import { Container } from 'react-bootstrap';
import Piechart from '../../../Litho/Components/PieChart/PieChart';
import colors from '../../../constants/colors';

const data = [
	{ percentage: 92, title: 'On-time performance' },
	{ percentage: 80, title: 'Global coverage' },
	{ percentage: 95, title: 'Customer satisfaction' },
];

const ChartsSection = () => {
	return (
		<section className='py-[130px] lg:py-[95px] md:py-[75px] sm:py-[50px] overflow-hidden'>
			<Container>
				<Piechart
					className='text-center'
					grid='row-cols-1 row-cols-md-3 row-cols-sm-2 justify-center gap-y-10'
					theme='piechart-style-01'
					data={data}
					pathColor={[colors.ttertiary, colors.tprimary]}
					trailColor='#f5f5f5'
					pathWidth={7}
					trailWidth={7}
					textStyle={{ fontSize: '32px', fill: '#232323' }}
				/>
			</Container>
		</section>
	);
};

export default ChartsSection;
